import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { Subscription } from '../../types/subscription';
import { getPlanById } from '../../constants/subscriptionPlans';

interface AvailableFeaturesCardProps {
  subscription: Subscription;
  className?: string;
}

const AvailableFeaturesCard: React.FC<AvailableFeaturesCardProps> = ({
  subscription,
  className = ''
}) => {
  const { language } = useLocalization();
  const plan = getPlanById(subscription.planId);
  
  if (!plan) {
    return (
      <div className={`p-6 bg-red-50 border border-red-200 rounded-lg ${className}`}>
        <p className="text-red-600">{language === 'ar' ? 'خطأ: لم يتم العثور على خطة الاشتراك' : 'Error: Subscription plan not found'}</p>
      </div>
    );
  }

  const features = language === 'ar' ? plan.featuresAr : plan.features;

  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 ${className}`}>
      {/* Header */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="text-2xl text-green-600">✨</div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              {language === 'ar' ? 'الميزات المتاحة' : 'Available Features'}
            </h3>
            <p className="text-sm text-gray-600">
              {language === 'ar' 
                ? 'جميع الميزات المتاحة في خطتك الحالية'
                : 'All features available in your current plan'
              }
            </p>
          </div>
        </div>
      </div>

      {/* Features List */}
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center space-x-3">
              <span className="w-2 h-2 rounded-full bg-green-500 flex-shrink-0" />
              <span className="text-sm text-gray-700">{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AvailableFeaturesCard;
